import { createApp } from '@wu/widget-core';
import { meta } from './constants';
import { PricingTable } from './pricing-table';

export default createApp(meta, PricingTable);
